import type { ReactNode } from 'react';

import RichText from '@/components/ui/RichText/RichText';

type SmartFormSplitLayoutProps = {
  heading?: { content: string };
  description?: { content: string };
  textPosition?: 'left' | 'right';
  form: ReactNode;
  className?: string;
};

export function SmartFormSplitLayout({
  heading,
  description,
  textPosition = 'left',
  form,
  className = '',
}: SmartFormSplitLayoutProps) {
  const textColumn = (
    <div className="w-full lg:w-1/2">
      {heading?.content && (
        <div className="mb-4">
          <RichText>{heading.content}</RichText>
        </div>
      )}
      {description?.content && <RichText>{description.content}</RichText>}
    </div>
  );

  const formColumn = <div className="w-full lg:w-1/2">{form}</div>;

  return (
    <div
      className={`content-wrapper flex flex-col gap-8 lg:flex-row ${className}`}
    >
      {textPosition === 'left' ? (
        <>
          {textColumn}
          {formColumn}
        </>
      ) : (
        <>
          {formColumn}
          {textColumn}
        </>
      )}
    </div>
  );
}
